import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ExcelService, LoaderService, ReportService} from '@app/shared/services';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import { ReportPdfComponent } from '@app/components/report-pdf/report-pdf.component';

@Component({
  selector: 'app-sale-report',
  templateUrl: './sale-report.component.html',
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent,
    ReportPdfComponent
  ],
  styleUrls: ['./sale-report.component.scss']
})
export class SaleReportComponent implements OnInit {
  @ViewChild('table') table?: ElementRef;
  user_rights: any;
  user_data: any;

  sale_data: any;
  closeResult = "";
  medicine: any;
  sale_return_quantity: any;
  sale_quantity = 0;
  fromdate = new Date();
  todate = new Date();
  start: any;
  limit: any;
  total_amount = 0;

  constructor(private loaderService: LoaderService, private modalService: NgbModal, public report: ReportService, private excelService: ExcelService,) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.fromdate = new Date(this.fromdate.getFullYear(), this.fromdate.getMonth(), 1, 23, 59, 59);
    this.todate = new Date(this.todate.getFullYear(), this.todate.getMonth() + 1, 0, 23, 59, 59);
    this.listSaleReport();
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  public listSaleReport() {
    const postData = {
      invoice_date_from: this.fromdate,
      invoice_date_to: this.todate,
      start: this.start,
      limit: this.limit
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.report.listSaleReport(postData).subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'success') {
        this.sale_data = result['data'];
        let total_amount = 0;
        for (const item of this.sale_data) {
          total_amount = total_amount + parseFloat(item.Amount)
        }
        this.total_amount = total_amount
      } else {
        this.sale_data = []
        this.total_amount = 0
      }
    });
  }

  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.sale_data, 'Sale');
  }

}
